// On-device tap counts that let Today learn what this trainer reaches for most. Never sent to the server.
const KEY = "kingly-taps";

export function readTaps() {
  try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { return {}; }
}

export function recordTap(key) {
  const taps = readTaps();
  taps[key] = (taps[key] || 0) + 1;
  localStorage.setItem(KEY, JSON.stringify(taps));
}

/** Stable sort: most-tapped first, ties keep the given (urgency) order. */
export function byTaps(items, keyOf, taps = readTaps()) {
  return items
    .map((it, i) => ({ it, i, n: taps[keyOf(it)] || 0 }))
    .sort((a, b) => b.n - a.n || a.i - b.i)
    .map((x) => x.it);
}
